import './blocks/content/special-popup.js';
import './blocks/offer-template-card.js';
import './containers/container.js';
import './blocks/offer.js';